// axios client
import client from './client';





// =========================
// 게시글 작성
// =========================

export const createPost = async (

    // title: string,
    //
    content: string,

    category: string

) => {

    // API 요청
    const response = await client.post(

        '/posts',

        {

            // title,

            content,

            category
        }
    );





    return response.data;
};





// =========================
// 전체 게시글 조회
// =========================

export const getPosts = async () => {

    // API 요청
    const response =
        await client.get(

            '/posts'
        );





    return response.data;
};





// =========================
// 인기 게시글 조회
// =========================

export const getTrendingPosts = async () => {

    // API 요청
    const response =
        await client.get(

            '/posts/trending'
        );





    return response.data;
};





// =========================
// 전체 게시글 조회
// =========================

export const getAllPosts = async () => {

    // API 요청
    const response =
        await client.get(

            '/posts'
        );





    return response.data;
};





// =========================
// 투표 API
// =========================

export const votePost = async (

    postId: number,

    voteType: string

) => {

    // API 요청
    const response = await client.post(

        '/votes',

        {

            postId,

            voteType
        }
    );





    return response.data;
};





// =========================
// 댓글 조회
// =========================

export const getComments = async (

    postId: number
) => {

    // API 요청
    const response = await client.get(

        `/comments/${postId}`
    );





    return response.data;
};





// =========================
// 댓글 작성
// =========================

export const createComment = async (

    postId: number,

    content: string
) => {

    // API 요청
    const response = await client.post(

        '/comments',

        {

            postId,

            content
        }
    );





    return response.data;
};





// =========================
// 댓글 삭제
// =========================

export const deleteComment = async (

    commentId: number
) => {

    // API 요청
    const response = await client.delete(

        `/comments/${commentId}`
    );





    return response.data;
};